// src/components/Footer.js
import { useEffect, useState } from 'react';
import styles from '../App.module.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const api_baseurl = process.env.REACT_APP_API_BASE_URL;
  const img_baseurl = process.env.REACT_APP_IMAGES_BASE_URL;
  const fetchHomeMenu =async() => {
    try {
      const response = await fetch(`${api_baseurl}get-top-menu.php`);
      const result = await response.json();
      setMenu(result.data); // Adjust based on your API response  
      setLoading(false)      
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)      
    } finally {}
  };
  useEffect(() => {
    fetchHomeMenu();
  }, []);

  return (
    <>
    {
      loading ? (
        <div className="animate-pulse bg-slate-500 w-full">
            <div className="w-full bg-slate-500 py-5">
              <div className="container">
                <div className="row">
                  <div className="col-md-5">
                    <div className="h-16 bg-gray-200 rounded w-52 dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-5/6 dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-5/6 dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-4"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-5/6 dark:bg-gray-700 mb-4"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/2 dark:bg-gray-700 mb-4"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-2"></div>                    
                    <div className="h-2 bg-gray-200 rounded w-2/3 dark:bg-gray-700 mb-2"></div>
                  </div>
                  <div className="col-md-3 ps-5">
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>
                    <div className="h-2 bg-gray-200 rounded w-1/3 dark:bg-gray-700 mb-3"></div>                    
                  </div>
                  <div className="col-md-4">
                    <div className="bg-gray-200 rounded py-2 flex justify-evenly items-center dark:bg-gray-700 mb-3">
                      <p className='w-1/3 mb-0'>Follow us </p>
                      <div className="w-2/4 grid grid-cols-4 gap-1">
                        <div className="h-9 rounded bg-gray-500 w-full"></div> 
                        <div className="h-9 rounded bg-gray-500 w-full"></div> 
                        <div className="h-9 rounded bg-gray-500 w-full"></div> 
                        <div className="h-9 rounded bg-gray-500 w-full"></div> 
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 text-center mt-4">
                      <div className="h-5 rounded bg-gray-500 w-3/4 mx-auto mb-2"></div>
                      <div className="h-2 rounded bg-gray-500 w-5/6 mx-auto mb-3"></div>
                      <div className="h-14 rounded-full bg-gray-500 w-5/6 mx-auto"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      ):(  
        <footer className={`bg-black text-white py-10 ${styles.footer}`}>
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <img loading="lazy" src={`${img_baseurl}images/logo.png`} alt='logo' className='img-fluid mb-3' style={{width:"40%"}}/>
                <p className="mb-0 text-white font-bold uppercase">
                  BlackPanther is a leading corporate event management company operating nationally from Mumbai, Delhi, Bangalore, Gurgaon, Pune and other cities in India.
                </p>
                <p className='text-yellow-400 mb-0 mt-3'>Get In touch</p>
                <p className="mb-0 text-white">
                  Address: F5-6, 5th floor, pinnnacle Business park, shanti nagar, mahakali caves road andheri east mumbai-400093.
                  <br/><br/>
                  Email: info@blackpanther.in
                </p>
                <p className='text-yellow-400 mb-0 mt-3'>Call us now</p>
                <p className="mb-0 text-white">09876543210</p>
                <p className='mt-3 text-gray-400'>&copy; 2024 BlackPanther Pvt. Ltd. All rights reserved</p>
              </div>
              <div className="col-md-3 ps-5">
                <p className='text-yellow-400 mb-0'>Company</p>
                <ul className="list-unstyled">
                  {                
                    menu.map((menuItem) =>
                      <li key={menuItem.url}><Link to={`./${menuItem.url}`} className='text-white no-underline mb-1 d-block'>{menuItem.menu_name}</Link></li>
                    )
                  }
                  {/* <li><a href="./services" className='text-white no-underline mb-1 d-block'>Services</a></li>
                  <li><a href="./event" className='text-white no-underline mb-1 d-block'>Event</a></li>
                  <li><a href="./about" className='text-white no-underline mb-1 d-block'>About Us</a></li>
                  <li><a href="./contact" className='text-white no-underline mb-1 d-block'>Contact Us</a></li> */}
                </ul>
              </div>
              <div className="col-md-4">
                <div className="bg-gray-500 text-white rounded-lg p-3 d-flex align-items-center justify-content-between">
                  <p className='mb-0'>Follow us </p>
                  <div className={`d-flex ${styles.footer_social}`}>                
                    <a href="javascript:void(0)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                      </svg>
                    </a>
                    <a href="javascript:void(0)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                      </svg>
                    </a>
                    <a href="javascript:void(0)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                      </svg>
                    </a>
                    <a href="javascript:void(0)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 text-center mt-4">
                  <p className='text-black font-bold text-3xl'>Let's get started</p>
                  <p className='text-black'>We'd love to hear about your project.</p>
                  <button className='btn bg-black text-white rounded-pill w-100 py-3'>Get in touch</button>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )
    }
    </>
  );
}

export default Footer;
